export { default } from './TiraVegueries';
